export const gtmProductClickEvent = (design: any, position: number, list: string) => {
  const productData = {
    ...design,
    list,
    position: Number(position),
  };

  return {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list,
        },
        products: [productData],
      },
    },
  };
};

export const gtmSelectItemEvent = (design: any, position: number, listName: string, extraParams?: any) => {
  const productData = {
    item_id: design?.id,
    family_id: design?.family_id,
    item_name: design?.name,
    publicDesignId: design?.publicDesignId,
    customerDesignId: design?.customerDesignId,
    item_category: design?.category,
    item_brand: design?.brand,
    affiliation: design?.marketing_material,
    price: design?.price,
    priceEUR: design?.priceEUR,
    dimension1: design?.dimension1,
    dimension2: design?.dimension2,
    dimension3: design?.dimension3,
    index: Number(position),
    item_list_name: listName,
    designIdEncLocale: design?.designIdEncLocale,
  };

  return {
    event: 'select_item',
    ecommerce: {
      items: [productData],
    },
    ...extraParams,
  };
};

export default gtmProductClickEvent;
